import { Store } from 'vuex'
import LinkItem from '~/types/LinkItem'
import loc from '~/utils/loc'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'

export default function catalogSubmenuItems (store: Store<any>, name: string): LinkItem[] {
  // каталог - корневой элемент
  // если данных в сторе не нашлось, то создаем их вручную
  if (name === 'Каталог' && s(store).categoryPage.pathSections.length === 0) {
    const items = s(store).general.sections.filter(e => !e.parentId)
    s(store).categoryPage.setPathSections([{
      name: 'Каталог',
      parentId: '-1',
      children: items,
      id: '0',
      alternativeDisplay: false,
      isPreset: false
    }])
  }
  const section = s(store).categoryPage.pathSections.find(e => e.name === name)
  let linkItems: LinkItem[] = []
  const helper = new SectionHelper(s(store).general.sections, store)
  if (section) {
    linkItems = section.children?.map((s) => {
      return {
        title: s.name,
        location: helper.getSectionPathById(s.id) ?? ''
      }
    }) ?? []
  }
  // дополнительно закидываем пару ссылок в Каталог в начало списка (как на боевом сайте)
  if (name === 'Каталог') {
    linkItems.unshift({
      title: 'Популярные товары',
      location: loc(store, {
        name: 'catalog-popular'
      })
    })
    linkItems.unshift({
      title: 'Товары по акции',
      location: loc(store, {
        name: 'stock'
      })
    })
  }
  return linkItems
}
